import React from "react";
import "./PlatformLogo.css";
import logo from "./assets/exl_logo.png";

const PlatformLogo = ({ appName, logoImgUrl }) => {
  return (
    <div className="platform-logo">
      <div className="platform-logo__box">
        <div className="platform-logo__box__img">
          <img className="b-w-filter" src={logo} alt="logo" />
        </div>
        <span></span>
      </div>
      <div className="platform-logo__name">
        <h1 className="platform-logo__name__1">{appName.part1}</h1>
        <h1 className="platform-logo__name__3">
          {appName.part2}
          <span className="platform-logo__name__2"></span>
        </h1>
      </div>
    </div>
  );
};

export default PlatformLogo;
